import(/* webpackMode: "eager" */ "/home/runner/work/build-a-dress/build-a-dress/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/runner/work/build-a-dress/build-a-dress/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/build-a-dress/build-a-dress/src/components/gallery/GalleryAmazonLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/build-a-dress/build-a-dress/src/components/gallery/GalleryDressPage.tsx");
